import axios from "axios";
import actions from "./action_types.js";
import mutations from "./mutation_types.js";

// each fetch action should return a axios promise
export default {
    [actions.FETCH_TRANSLATIONS]: function(store, text) {
        return axios
            .post("/translations/translate-array", { keys: text}, {
                headers: { "X-CSRF-TOKEN": document.querySelector('input[name="_token"]').getAttribute("value")}})
            .then(response => {
                store.commit("setLang", response.data.lang);
                store.commit("addTranslations", response.data.translations);
            });
    },
    [actions.FETCH_USER_INFO]: function(store) {
        return axios.get("/user-settings/user-info").then(response => {
            store.commit("setUserInfo", response.data);
        });
    },
    [actions.FETCH_SELECT2_CONTRACTORS_LIST]: function(store) {
        return axios
            .get("/summaries/contractor-history/contractors-list")
            .then(response => {
                store.commit(mutations.ADD_SELECT2_CONTRACTORS, response.data);
                store.commit(mutations.ADD_SELECT2_ID_NUMBERS, response.data);
            })
            .catch(error => {
                console.log(error.message);
            });
    },
    [actions.FETCH_SERVER_INFO]: function(store) {
        return axios
            .get("/server-info")
            .then(response =>
                store.commit(mutations.SET_SEVER_INO, response.data)
            );
    },
    [actions.FETCH_SELECT2_DOCUMENTS_CURRENCIES_LIST]: function(store) {
        return axios
            .get("/summaries/receivables-and-liabilities/currency-list")
            .then(response => {
                store.commit(
                    mutations.ADD_SELECT2_DOCUMENTS_CURRENCIES,
                    response.data
                );
            })
            .catch(error => {
                console.log(error.message);
            });
    },
    [actions.SAVE_COUNTRIES_TRANSLATIONS]: function(store, translations) {
        store.commit("setCountriesTranslations", translations);
    }
};
